import React from 'react';
import './ReportListLoader.css';

const ReportListLoader = ({ isLoading, text = "Chargement des rapports..." }) => {
  if (!isLoading) return null;

  return (
    <div className="report-list-loader">
      <div className="report-list-loader-content">
        <div className="report-list-loader-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <p className="report-list-loader-text">{text}</p>
      </div>
    </div>
  );
};

export default ReportListLoader;